<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>{{data.message}}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onValidate()">{{'key__label_continuer' | translate}}</button>
  <button mat-button mat-dialog-close>{{'key_input_cancel' | translate}}</button>
</mat-dialog-actions>
